module.exports = __webpack_public_path__ + "img/7.ccbd6035.jpg";